import "../pagesCss/comingSoon.scss";
import React, { useState } from "react";
import axios from "axios";


function Comparateur() {
  const [formdata, setFormdata] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    service: "Comparateur",
  });
  
  const [error, setError] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  
  const submitHandler = async (event) => {
    event.preventDefault();
    if (!formdata.email) {
      setError(true);
      setMessage("Veuillez renseigner votre Email");
    } else {
      setError(false);
      setMessage("Votre message a été reçu!!!");
    }
  
    setLoading(true);
    try {
      let url = "http://localhost:1337/api/messages";
      const res = await axios.post(url, { data: formdata });
      console.log("data from message post", res.data.data);
      setLoading(false);
      setFormdata({ name: "", email: "", subject: "", message: "" })
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  };
  
  const handleChange = (event) => {
    setFormdata({
      ...formdata,
      [event.currentTarget.name]: event.currentTarget.value,
    });
  };

  const handleAlerts = () => {
    if (error && message) {
      return <div className="alert alert-danger mt-4">{message}</div>;
    } else if (!error && message) {
      return <div className="alert alert-success mt-4">{message}</div>;
    } else {
      return null;
    }
  };
  
  return (
    <>
      {/* <header>
        <div className="logo">
          <img
            className="logo"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAuCAYAAAB3ebaPAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAMrUlEQVR4Xu2ce4xfRRXHWxVBUbtVgzHBtPVt1W7XB6H42K0YiWJp6wuFhLZE/vHVVkWJFdiaGEN8tKsEo0T6EISopQ/SaLR0W7AUoe22jSDY6m41GtTSblFEInT9fCczw+zsnfu7v0dhdzs3udnfb+bMmXO+c86ZmTPz2wkT8pMRyAhkBDICGYGMQEYgI5ARyAhkBDICGYGMQEMITGyoVcVG27ZtmwXpc3gndnV13VGxWSbLCIxtBPr7+09ZvXr1goULF94wderUv6LNUOql/gh0a6G/hHZtY1vzLH1GIECgt7f3fCJ/f5kD1Kqj/Q45RwY2IzBmEcAR5hDpk7NALScoqoff39avX3/BmAUlC35yIrBkyZIfN2LwVdvMmzdv08mJbNZ6zCFAFB+satjN0LW1tf27r6/v9WMOoCzwyYMARnq4GSOvty39PY5TvOnkQThrOmYQwDifqNegW0FPv//FKaaPGaCyoOMfAbJAv26FcTfKY+bMmfeNf5Tr13DVqlUfotVxgsYRkhHvrZ/D6GyhFD5L8wPSjfT8D0aVlCtWrPhMo4bcynZX84wqYEaHMMcdxp2dnbePDpGal4Kh/pKcwep2nIzmWY1yBZdehxF8r6rCR6fIyWf58uXX2EqlWJOn2lOmTDly6NChF1fpMKSh3QTa1WyGHN1Ejp5p06YN1iRuEQER+BPI9koBumDBguuezr6lQnd3twzjWcKdz9+I1Wpvb+/bt2/fW1RORB3Yvn17izR/Ztmgi861zDNp0qRHwu9NSiYsG38wCJ0JyFPdmzx3gHYhRnOjjKfqi/fuxvs7q9Lj4Vc2rk39LW3UNfog59vr59B0Cz8DpDgxg3+K99NN9zTKGLAEPI/x/ipB8OXNiBbNEN3N8JrA3uEXVZyBKP9PdYTwZ1Y1bmtk71Y7hL6zSjtFwaYUqrMxcm1xcuEQb6vSHAxOr0LnaEgYTCmhD4NLPWwLaZHtJWVMqJ9cTye1+NXo64x6+krRgt9ry/i01CHo6MkqDqHZwQnFLLG2inFbJzDNbPStNLMAwLQyANiEfZ9N5sNObm04KbuewXte1QHQZpVg8Cu1dbqwsd9D2e16Yz4sZy63fXodOFxch6yviWkpO5O6n1r5PD3O/mfk/JHoFy9e/E3bj6/n+128O6n7ruMJhrosaWiIpt2u3M6kphz6lRykfgf5/udo6esRMO8Sva7M6G5ZOGbQr0hhpbFC/vUhPbyH1MfRo0dPC9vZtb+RA1nv0i0EcPx92BadV9tA6pvS7h2RDfk65L3YXhIdZi/w3Q//ubHcLXMIBk7KOYdQ5+H07ZTcNnfu3I2hEJriKNvE+vYPkVKmDeX3I+T22FgYuG9JeNaMjxe1c2WpDRb8XhQ6QiwvdYM1orFXI9rUFTmqoUXX0zCmP6bkVaqaQTrfMUZ2rfeTjo/uj2FUzw0HMaan7h7Hj8+/cfXI/DVXbhMQNQMMhrUnJQ8GpvEb9oSOVtROjgHGMwJ9z3F0qivBaQgs/UwJTu8qcgjK31mGn+pYPi4JhW6ZQ9C5NpPh3sE4hCKlBi0GK/UdRacqugHUzKptRMdMU3g9xGa9RrBCrl1OXq39kb9D0Qw+irpmMBiUo1VkYIb4sJZLGKjonSPvF7gWYMOGPne7epVj/O+nz1k497eDPp8AL7OZI1Csc+V83gDtOXrR6bO03+EyaWrP923h4PP9br3Ufc/pEM0QSYdADyUFbqTPzUUGRZA6RP1NLH0fDevBYYHryzq2N2r6vlezkmQWf9eOAKGZyDwFkV4B8S+a5fj7YNgX/d8ctCt0CNULJ+Q8SrfLNSMocwQvpeXdGA+B9/MDjLa6unAWrWIHw2joTL9jKNxM64p3FYZyHJxBqQ850r4qbUTDQFxUNHAqK9pYQ6+p0shalH7EEG51/KD9eFU5ok21op1/7J7CDAIDNICuw7J1YTR1TszA+YgMvnMqyFG6hyhxCKUXTVsZaxiMbAT1fMFGZ0z+kaG7thjpT1wF4/eAK4/boPvpoVO4JXQc0eGnpaJ/tJJwPOm3z1WkZgjVE2BfFuNG/6fSv1YzRi/am72pHviGDnF1BczNj3dGPERTs1EueljHLcIptP68NEWDkBNnz569a+/evW8WDX9naHbhr0kTph7A/NiiRYtuStUTgf4U18HzbFs2kWeINf1X3Hf+ThwYGPAzA7TaHN+CwX6ZVO6IVCZgvhW5/eCk5OCHT+e5OtKx/T09PVfQr4qUmh6iT7/X2bBhw0cou1b6kybtENH8+fM38f1+9DmomUZO29HR8bsybArqFATcE372hQSkX8J3ryvQQdfSpUv9HoG1/9c3bnxq1Qv9ZtK3JoGADm9w7cDtde6z0sFhm8mTJz+qqA8GnxONxWZ1LK/arVmzxhfT9zXwMYGBPmfW0kX1YP13XeeB/tzBwUElAYbodwgZBo8dO2bS/tbGGv4xWqFDYBQHywZHTkG06QNcP4WH9AC/zjlDAGqHoq6UKeJN1OzEUG4p69eu2YeR0I9SouaMhME4V2+KR+CQz07QpM5lUvTqs0tvmdyqW7ly5WX0fxZO4YLEdL5Px2EuwFiWY4x368RZBlaLl61XRCx6fDnOdk9kvI9V5C0ys9QjKp+BIfpmONiIgKE9miPAkbzzhH3BY6Bi3ym9lPncTv9+Bijih6O01cKlTI7kwRzTkLxOzCVg0aFc8qAuBCjqvKyNLg+W/qQVh9DUPexR5HVOprU5kcet4cODGAOyLigCqIDVUiGsN/3aKwOOf6Wf12pzi0Evo5GitJkh7Cs+5mqF+sTQVT5Dd7Nwgo9iOK/CIWbhIK8WIU51NoHmk3zsqWg4IVnSiGrwinUMv5vPGPI/Qh7MosTL2b1hGUboU7pg+OCJOCRkyXUDM4xxBpafDzHOy+yhnbJca8HxFVam1LhVGs8kXghwvR3kERkmlWsDmWqsQ5XAMPya1W44y8YomY2wa84Rbe09HrepGnEZkOXbC6D5YL1GFq4/4zW/zZJ5Wfn+xpC/UpDg45Zyvqood283e4aXTVs7+pB/eyx/uPFOpV21+SzQ2/OVcYf1oSzw3+/qlDZ140kw2Yt+ba7O7lE8T7Cap7qCrNAwUVLpVSUaItsx7UJ9Y7kJiv2uTahzI3uI5HE2Xhfe/QgjkPlMlNipv0S1i7S2B6itzgi0di0yQLcH0FpduXZlfmx0rWmv5L9/XkTEMmuLrjGojkh1KtH4PuXK4XslS7dVRLh/QXMbfXbW7CQgQFZ/p4R9zSb4XSW+GMMp9HEAB13vyLX+p+5W6aLzBF3zED7siS52NAzUMsoPW9muEj+9LGkudDSa7QIj9Hcx6P9n0HYrb1+PDhVo45kl/K6Nqnno+gr3mZmsHX0fRpabGcPd4RKKcTgM1hssba2InLK9VLlftjJTXCZHRJZO8NzMTDs1oWstGSpAFJDYTEucbTqulKRzBOeZ7i8g9VpDGBHtlUHSoVXcRlMf/C6kv8JTazI5D5VJLiNlMJTJSs4wzE7X1qO9zY2P4Ody3cpuxOnRuP/QacKDviI5dUajjI2TkUj7gSI6l0Whb5PB0xtGRXuJzZX7dGygezhDdIWYRDOEd07RKHsUZpNi2bSMCWcOG4BC/IbBn6pPlduZp3B8sY//FGHRsnMIJzlG8UI+O4eI/yaNr8wwG6mz029Ne2bQLsUIt4YDx/c7KdfavO6HKNRBex0YGl0B/hgO8fmQkfL10NwGjV9ayrEpvySkA8uX4pQrtOcIMeD7TjlZmD937bSsUL3rH6M7SJkxYp1Ci5eWM+FtAcljy3/L50Wx0pKNd4/e+HxIfCjXmce9RQFE50qUX4cc/j+raGmF/F+M+4F3u2Tn3c1rZvDwUd+U7+M9wOuTOLZc8j3Aq5Nt/0h3sNbqw43Hcfr+gvSEdpfeEAuL9x12PBbWbQBFDYKT22fEITTwLVEkM8kItAoBNnv6oYa8svCwLox4rfwcbTJbpU7mkxFoHgGM84dPp0PQ31OnOM2LnzlkBFqLAOs3Xdxys8QJ3T/kZVJrxy5zOwEIsJe4/EQ7BJvWwzY/fQI0yCwzArURKP0JadQ8zOlqhmhZjlc3GMlr9+huDSe6+g8f+ckIjG4EUhtr5dqpW1WWo05ttJVLj9OToxuFLN14R6BylMd4t4QX8+QAHKbN4WRS9+zNo5/0cXr4Pt1E5O974hmGk9g+3XPi8G4LJ7k7xju4Wb9xjAAO4e+W6wRQB03jWN2sWkagJgL6wcmTqV+t1WydCTIC4wkBjut3syTST0vzkxHICGQEMgIZgYxARiAjkBHICGQEMgIZgYxARiAjkBHICGQEMgJJBP4PSVoIFozAQQ8AAAAASUVORK5CYII="
            alt="logo"
          />
        </div>
      </header> */}

      <div className="container">
        <h1>Yearch: le moteur de recherche, ARRIVE BIENTÔT</h1>
        <p>
          Trouvez les meilleurs prix pour vos produits locaux, et services en un
          clin d'œil avec Yearch, le nouveau moteur de recherche de comparaison
          de prix. Inscrivez-vous dès maintenant pour être le premier à en
          profiter ! #Yearch #comparateurdeprix #produitslocaux
        </p>
        <form className="join-wrapper" onSubmit={submitHandler}>
          <input
            type="email"
            id="email"
            placeholder="Saisir votre email"
            name="email"
            onChange={handleChange}
            value={formdata.email}
          />
          <button type="submit" name="submit" id="submit" >
            Je veux
          </button>
        </form>
        {handleAlerts()}
        <p className="result"></p>
        <div className="creators">
          {/* <div>
            <img src="https://i.pravatar.cc/150?img=3" alt="" />
            <img src="https://i.pravatar.cc/150?img=3" alt="" />
            <img src="https://i.pravatar.cc/150?img=3" alt="" />
          </div> */}
          <p>Rejoignez des centaines de personnes interessées !</p>
        </div>
      </div>
    </>
  );
}

export default Comparateur;
